import { v2 } from "../../lib/api-v2";
import type {
  OrderDetails,
  OrderPage,
  OrderRefund,
  OrderTotals,
  PaymentBreakup,
  PlacedOrder,
  RazorpaySuccess,
  RefundRequest,
} from "./types";

/** Order REST calls, through the shared v2 client. All are for the signed-in account. */

const order = (orderId: string) => `/orders/${encodeURIComponent(orderId)}`;

/** Subtotal, GST and total for the checked-out cart. */
export const getQuote = () => v2.get<OrderTotals>("/orders/quote");

/** Starts paying for the checked-out cart (the same pending order if asked again). */
export const placeOrder = () => v2.post<PlacedOrder>("/orders");

export const verifyPayment = (orderId: string, result: RazorpaySuccess) =>
  v2.post<OrderDetails>(`${order(orderId)}/verify`, result);

/** Re-checks the payment with Razorpay. */
export const refreshOrder = (orderId: string) => v2.post<OrderDetails>(`${order(orderId)}/refresh`);

export const getOrder = (orderId: string) => v2.get<OrderDetails>(order(orderId));

/** How the order was paid: every payment attempt, oldest first. */
export const getPaymentBreakup = (orderId: string) => v2.get<PaymentBreakup[]>(`${order(orderId)}/payment-breakup`);

export const listOrders = (beforeId?: string | null, limit = 20) => {
  const qs = new URLSearchParams({ limit: String(limit) });
  if (beforeId) qs.set("before_id", beforeId);
  return v2.get<OrderPage>(`/orders?${qs}`);
};

/** What a refund of the order's unused credits would return now, and its requests. */
export const getOrderRefund = (orderId: string) => v2.get<OrderRefund>(`${order(orderId)}/refund`);

/** Asks for the order's unused credits to be refunded; a TechLadder admin reviews it. */
export const requestRefund = (orderId: string, reason: string) =>
  v2.post<RefundRequest>(`${order(orderId)}/refund-requests`, { reason });
